import styled from "styled-components";
import { colors, media, fonts, getOuterSpace } from "../../style/constants";

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  ${getOuterSpace("padding")}
  ${media.md`
    position: static;
    padding: 0;
  `}

  > div {
    position: relative;
  }

  a,
  svg {
    display: block;
  }

  a {
  }

  svg {
    width: 100%;
    height: auto;
  }

  .circle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0);
    background: rgba(255, 255, 255, 0.05);
    height: 100%;
    width: 100%;
    border-radius: 100%;
    pointer-events: none;
    opacity: 1;
    will-change: transform;
  }

  .logo {
    display: flex;
    justify-content: space-between;
    text-transform: uppercase;
    font-weight: 200;
    font-size: 10rem;
    line-height: 1;
    color: ${colors.red500};
    width: 40vw;
    max-width: 40rem;
    font-family: ${fonts.tall};

    ${media.md`
    width: 100%;
    max-width: initial;
  `}
  }

  .spaced {
  }

  a:hover + .circle {
    opacity: 0;
    transform: translate(-50%, -50%) scale(7.5);
    transition:
      transform 1s cubic-bezier(0.45, 0, 0.1, 1),
      opacity 0.8s ease;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Logo/style.js